<template>
	<div class="optionalObjectField">
		<h5>{{componentItemKey}}</h5>
		<div v-if="hasField">
			<span v-if="typeof componentItemContent[componentItemKey]  != 'string'">
				<template v-for="(content, i) in componentItemContent[componentItemKey]">
					<div v-if="typeof content !== 'object'" :key="i" class="form-group col-md-6">
						<input type="text" class="form-control" :id="i" v-model="componentItemContent[componentItemKey][i]" >
					</div>
				</template>
			</span>
			<span v-else >
				<ImageUploader 
					v-if="componentItemKey === 'logo' && forTemplate == 'client-box'" 
					:size="'sponsor'" 
					:forTemplate="forTemplate" 
					:imageFieldKey="componentItemKey" 
					:imageFieldObject="componentItemContent" >
				</ImageUploader>
			</span>
		</div>

		<div v-if="!hasField">
			<button type="submit" class="btn m-2 icons-round" @click.stop.prevent="addSampleObject">
				<img src="~@/assets/icons/add.svg">
			</button>
		</div>

		<button v-else type="submit" class="btn m-2 icons-round" @click.stop.prevent="removeObject">
			<img src="~@/assets/icons/minus.svg">
		</button>

	</div>
</template>

<script>

	import ImageUploader from './ImageUploader';

	export default {

		name: 'OptionalObjectField',
		
		components: {
			ImageUploader
		},		

		props: ['componentItemContent', 'componentItemKey', 'componentItemSampleContent', 'forTemplate'],

		data() {
			return {
				hasField: false,
			}
		},
		
		mounted() {
			if(this.componentItemContent[this.componentItemKey]) {
				this.hasField = true;
			}
			console.log(this)
		},

		methods: {
			addSampleObject() {
				this.componentItemContent[this.componentItemKey] = this.componentItemSampleContent
				this.hasField = true;
			},
			removeObject() {
				delete this.componentItemContent[this.componentItemKey];
				this.hasField = false;
			},
		}

	}

</script>

<style lang="scss" scoped>
	@import '@/scss/style.scss';

	label {
		display: block;
	}

	html {
		font-size: 16px;
	}

	.btn:not(:last-of-type) {
		margin-right: 15px;
	}
	
</style>